import FormControlLabel from '@zenbusiness/zui/FormControlLabel';
import { styled } from '@zenbusiness/zui/styles';

export const FormControlLabelStyled = styled(FormControlLabel)(
  ({ theme, selected }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: 16,
    backgroundColor: theme.palette.background.paper,
    borderRadius: 12,
    border: `2px solid`,
    borderColor: selected ? theme.palette.info.main : theme.palette.border.main,
    [theme.breakpoints.up('md')]: {
      padding: 24
    },
    cursor: 'pointer',
    margin: 0
  }),
  { shouldForwardProp: (prop) => prop !== 'selected' }
);
